import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { ControlEscrituraMasivaComponent } from './ControlEscriturasMasiva.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'ControlEscriturasMasiva',
        component: ControlEscrituraMasivaComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ControlEscriturasMasiva'
        } 
    }
];

@NgModule({
    declarations: [
        ControlEscrituraMasivaComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ControlEscrituraMasivaComponent
    ],
    bootstrap: [ControlEscrituraMasivaComponent]
})


export class ControlEscrituraMasivaModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ControlEscriturasMasiva/ControlEscriturasMasiva.module.ts